// 游客名单

export default [
  {
    path: '/tourist',
    redirect: '/tourist/name'
  },
  {
    path: '/tourist/name',
    component: () => import('@/views/tourist/Name'),
    meta: {
      title: '游客名单'
    }
  },
  {
    path: '/tourist/order',
    component: () => import('@/views/tourist/Order'),
    meta: {
      title: '上传名单'
    }
  },
  {
    path: '/tourist/edit',
    component: () => import('@/views/tourist/Edit'),
    meta: {
      title: '编辑名单'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/tourist.js